import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SelectInput from "src/_common/components/form-elements/selectinput/selectInput";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import {
  useAppEvenListSelector,
  useAppEventGameListSelector,
  useAppEventLeaderBoardSelector,
} from "src/_common/hooks/selectors/eventSelector";
import { useAppGuestUserIdSelector, useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { CRYPTO_SECRET_KEY, removeTrailingZero, URLS } from "src/_config";
import Sponsor from "src/components/common/Sponsor";
const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoEventLeaderBoardPage() {
  const eventApi = useEventApi();
  const leaderBoardSelector = useAppEventLeaderBoardSelector();
  const history = useHistory();
  const { eventId, performanceId, groupId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  // const p_id: number = parseInt(cryptr.decrypt(performanceId));
  const eventGameListSelector = useAppEventGameListSelector();
  const eventListSelector = useAppEvenListSelector();
  const guestUserId = useAppGuestUserIdSelector();
  const userDetails = useAppUserDetailsSelector();
  const [loginReq, setLoginReq] = useState<any>(0);
  const [leaderboardType, setLeaderboardType] = useState<any>(0);
  const [leaderboardList, setLeaderboardList] = useState<any>();
  const [listOptions, setListOptions] = useState<any>([{ label: "Overall", value: "0" }]);
  const eventAction = useAppEventAction();
  const tiebreakerText = "RANDOM DRAW NUMBER (to be used for tie breaker): ";

  const getEventGameList = () => {
    const params: any = {
      rodeo_event_id: e_id,
      game_id: eventListSelector?.game_details.id,
    };
    if (!userDetails) {
      if (guestUserId) {
        params["guest_user_id"] = guestUserId;
      }
    }
    eventApi.callGetEventGameList(
      params,
      (message: string, resp: any) => {
        if (resp) {
          // eventAction.updateLoginRequired(resp.rodeo_event_dtls.login_required)
          // console.log(resp)
          setLoginReq(resp.rodeo_event_dtls.login_required);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const goBack = (e: any) => {
    e && e.preventDefault();
    // history.push(`/event/${eventId}`)
    history.goBack();
  };

  const callViewLeaderBoard = (locId?: any) => {
    const params: any = {
      rodeo_event_id: e_id,
    };
    if (performanceId) {
      params["performance_id"] = parseInt(cryptr.decrypt(performanceId));
    }
    if (locId) {
      params["location_id"] = locId;
    }
    eventApi.callViewLeaderBoard(
      params,
      (message: string, resp: any) => {
        if (resp) {
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const getLeaderboardLocationList = () => {
    // if(location) {
    //     let loc: any = location;
    let params: any = {
      type: "game",
      rodeo_event_id: e_id,
    };
    if (performanceId) {
      params["performance_id"] = parseInt(cryptr.decrypt(performanceId));
    }
    // else if(params.performance_id) {
    //   params["type"]="performance"
    // } else if(params.rodeo_event_id) {
    //   params["type"]="game"
    // }
    eventApi.callGetLeaderboardLocationList(
      params,
      (message: string, resp: any) => {
        //   console.log(resp?.locations?.length>0)
        if (resp?.locations?.length > 0) {
          let x: any = listOptions;
          resp?.locations?.map((loc: any) => {
            x.push({ label: loc.title, value: loc.location_id });
          });
          // console.log(x)
          setListOptions(x);
        }
        // if (resp) {
        //   console.log(leaderboardData)
        // }
      },
      (message: string) => {
        // toast.error(message)
      }
    );
    // }
  };

  const handleListChange = (data: any) => {
    //   console.log({data})
    if (data?.value) {
      callViewLeaderBoard(data?.value);
    }
  };

  useEffect(() => {
    if (userDetails) {
      getLeaderboardLocationList();
    }
  }, [userDetails]);

  useEffect(() => {
    callViewLeaderBoard();
    // getEventGameList()
    // if(eventGameListSelector.filter((x:any)=>x.ispicked).length)
    // {

    // }
  }, []);

  // useEffect(() => {
  //     if (userDetails || loginReq==0)
  //     {
  //         history.push(`/event/${eventId}`)
  //     }
  //     else
  //     {
  //         history.push(`${URLS.LOGIN}`)
  //     }
  // }, [loginReq])

  useEffect(() => {
    let x = leaderBoardSelector?.rodeo_event_game_info?.show_leaderboard;

    if (x) {
      setLeaderboardType(x);
      if (x == 1) {
        setLeaderboardList(leaderBoardSelector?.players);
      } else if (x == 2) {
        setLeaderboardList(leaderBoardSelector?.riders);
      } else {
        setLeaderboardList(leaderBoardSelector?.events);
      }
    }
  }, [leaderBoardSelector]);

  return (
    <React.Fragment>
      <h2 className="page-title text-left">
        <Link to="#" onClick={(e) => goBack(e)} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </Link>
        Leaderboard
      </h2>
      <div className="text-center text-white pb-3">{leaderBoardSelector?.rodeo_event_dtls?.title}</div>
      <div className="text-center text-white pb-3">
        {leaderboardType == 1
          ? performanceId && leaderBoardSelector?.performance_dtls?.tie_breaker_code
            ? tiebreakerText + leaderBoardSelector?.performance_dtls?.tie_breaker_code || ""
            : (leaderboardList?.length && leaderboardList[0]?.per_tie_total
                ? tiebreakerText + leaderboardList[0]?.per_tie_total
                : "") || ""
          : null}
      </div>
      {userDetails && leaderBoardSelector?.rodeo_event_dtls?.is_assign_geo_location == "1" && (
        <SelectInput
          onChange={handleListChange}
          value={undefined}
          defaultValue={{ label: "Overall", value: "0" }}
          options={listOptions}
          // error={errors.country}
          placeholder="Select"
        />
      )}
      <div className="score-range-wrap">
        <div className="score-box d-flex justify-content-between">
          {/* <h4 className="d-inline-block title-player">{leaderboardType==3 ? "Events" : "Riders"}</h4> */}
          <h4 className="d-inline-block title-player">
            {leaderboardType == 3 ? "Events" : leaderboardType == 1 ? "Correct Picks" : "Riders"}
          </h4>
          {leaderboardType == 1 ? <div className="gua-sc">{"Tie Breaker Code"}</div> : null}
          <div className="gua-sc">{leaderboardType == 2 ? "Vote Received(%)" : "Result"}</div>
        </div>
        <ul className="cons-list">
          {leaderboardList && leaderboardList?.length ? (
            leaderboardList?.map((item: any) => (
              <li key={item.id}>
                <span className="name-img leaderboard-name-img flex-fill">
                  {/* <em className="user-img-wrap">
                    <img
                      src={
                        leaderboardType == 2 && item?.rider?.id != 0
                          ? item?.rider?.thumb
                          : leaderboardType == 2 && item?.contestant_dtls?.avatar?.id != 0
                          ? item?.contestant_dtls?.avatar?.thumb
                          : leaderboardType == 1 && item?.user_details?.avatar?.thumb
                          ? item?.user_details?.avatar?.thumb
                          : leaderboardType == 3
                          ? item?.event_truck?.id != 0
                            ? item?.event_truck?.thumb
                            : item?.rodeo_pick_event?.avatar?.thumb
                          : "/images/no-image.png"
                      }
                      alt={item.name}
                    />
                  </em> */}
                  {leaderboardType == 2
                    ? item?.name
                    : leaderboardType == 1
                    ? item?.user_details?.display_name || item?.user_details?.full_name
                    : leaderboardType == 3
                    ? item?.event_name || item?.details?.rodeo_pick_event?.title
                    : ""}
                </span>
                {leaderboardType == 1 ? (
                  <span className="count-vote p-0 flex-fill" style={{ textAlign: "center" }}>
                    {/* {performanceId ? item?.lucky_number || "-" : item?.user_tie_total || "-"} */}
                    {item?.user_tie_total == 99999 || item?.user_tie_total == 9999999
                      ? "-"
                      : item?.user_tie_total || "-"}
                  </span>
                ) : null}
                <span className="count-vote flex-fill">
                  {userDetails &&
                  eventGameListSelector?.filter((x: any) => x.ispicked).length > 0 &&
                  leaderboardType == 2 &&
                  item.vote
                    ? removeTrailingZero(item.vote)
                    : leaderboardType == 1 && Number(item?.total_win)
                    ? // ? item?.total_win + "/" + leaderBoardSelector?.events_count
                      item?.total_win + "/" + leaderBoardSelector?.start_end_events_count
                    : leaderboardType == 3 && Number(item?.total_win)
                    ? item?.total_win
                    : "-"}
                  {/* {
                      leaderboardType==2 && item.vote ? removeTrailingZero(item.vote) : leaderboardType==1 && item?.total_win ? item?.total_win+"/"+leaderBoardSelector?.events_count : leaderboardType==3 && item?.total_win ? item?.total_win : '-'
                  } */}
                  {/* {
                      leaderboardType==1 && item?.total_win ? item?.total_win+"/"+leaderBoardSelector?.events_count : (eventGameListSelector?.filter((x:any)=>x.ispicked).length>0 ? (leaderboardType==2 && item.vote ? removeTrailingZero(item.vote) : (leaderboardType==3 && item?.total_win ? item?.total_win : '-')) : '-')
                  } */}
                </span>
              </li>
            ))
          ) : (
            <li className="no-rider">No record found!</li>
          )}
        </ul>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
